import type { WebModul } from '../../core/modul';
import { Symbol } from '../../core/symbole';
import { Karte, Startkarte } from './Karte';
import { Seite } from './Seite';

/**
 * Ideen: eigene Seite oben in der Kopfleiste (/modul/ideen), auch ohne Projekt (Marc, 04.11.).
 * Kein Reiter im Projekt; auf der Projektübersicht erscheint nur die Karte mit den Ideen des Projekts.
 */
const ideen: WebModul = {
  id: 'ideen',
  name: 'Ideen',
  reihenfolge: 60,
  symbol: Symbol.ideen,
  GlobalSeite: Seite,
  globalName: 'Ideen',
  Karte,
  Startkarte,
};
export default ideen;
